import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=44f20044&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=js&"
export * from "./Player.vue?vue&type=script&lang=js&"
import style0 from "./Player.vue?vue&type=style&index=0&id=44f20044&prod&lang=scss&"
import style1 from "./Player.vue?vue&type=style&index=1&id=44f20044&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f20044",
  null
  
)

export default component.exports